module.exports = __webpack_public_path__ + "images/cabbage_web-b0a49c782affd0dbf9d882e77029a7f5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/cabbage_web.svg
// module id = 212
// module chunks = 0